<template>
  <div class="container-fluid p-0" Id="DetailCustomer">
    <Card v-if="$store.state.renderComponentCard" back>
      <template v-slot:header>
        <h4 :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-warning' : ''" class="d-inline">{{ Customer.Customer.CustomerName }}</h4>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;زمان ایجاد: &nbsp;<span>{{ Customer.Customer.DateTimeInsert }} </span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; کاربر ایجاد کننده: &nbsp;<span>{{ Customer.Customer.NamFamIjadKonanade }} </span>
        <div :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-warning' : ''" class="d-inline float-left ml-5">
          <span :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-warning' : ''">کد بازاریابی : </span>
          <h3 class="d-inline">{{ Customer.Customer.CodeBazaryabi }}</h3>
        </div>
        <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center" toggle-class="text-decoration-none " no-caret>
          <template #button-content
            ><h4><i class="fad fa-ellipsis-v text-secondary"></i></h4
          ></template>
          <b-dropdown-item href="#" class="text-center" @click="OnEditCustomer">ویرایش</b-dropdown-item>
          <b-dropdown-item href="#" class="text-center" @click="OnCustomerFinancialInvoice">تنظیمات مالی</b-dropdown-item>
          <b-dropdown-item v-if="$session.get('Menu').filter((x) => x.RouteName == 'AddCustomer')[0].isMojaz == 1" href="#" class="text-center" @click="OpenLog"> لیست تغییرات</b-dropdown-item>
        </b-dropdown>

        <hr />
      </template>
      <template v-slot:content>
        <div class="container-fluid text-center">
          <div class="row w-100">
            <div class="col-md-2 col-12 text-center">
              <div class="LogoCustomer">
                <i style="font-size: 125px" :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-warning' : ''" class="fad fa-user-tie"></i>
              </div>
            </div>
            <div class="col-md-3 col-12 text-center">
              <div class="mt-1" :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-danger' : ''">
                <span class="mt-1" :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-danger' : ''"> وضعیت : </span>
                <span class="mt-1" :class="[1312, 1656, 1664].indexOf(Customer.Customer.tblCombogrp37AxarinVazeit) >= 0 || Customer.Customer.Baygani ? 'text-danger' : ''">{{ Customer.Customer.tblCombogrp37AxarinVazeitName }} </span>
              </div>
              <div class="mt-3">
                <span class="d-inline">شماره مشتــری</span>
              </div>
              <div class="">
                <h5 style="color: var(--logo-color) !important; font-size: 35px !important" class="d-inline">{{ Customer.Customer.CustomerCode }}</h5>
              </div>
            </div>
            <div class="col-md-3 col-12 text-center">
              <div v-if="Customer.Customer.tblUserIdRabetPoshtibaniNamFam != null && Customer.Customer.tblUserIdRabetPoshtibaniNamFam != ''" class="mt-2">
                <span> رابط پشتیبانی : </span><span> {{ Customer.Customer.tblUserIdRabetPoshtibaniNamFam }} </span>
              </div>
              <div v-if="Customer.Customer.tblUserIdRabetForoshNamFam != null && Customer.Customer.tblUserIdRabetForoshNamFam != ''" class="mt-2">
                <span> رابط فروش : </span><span> {{ Customer.Customer.tblUserIdRabetForoshNamFam }} </span>
              </div>
              <div class="mt-1" v-if="$IsAccess('lblCustomerRemember')">مبلغ بدهی :</div>
              <div class="mt-1" style="font-size: 22px" v-if="$IsAccess('lblCustomerRemember')">
                <span :class="Detail.Remember > 0 ? 'text-warning' : 'text-info'">{{ $Comma3ragham(Detail.Remember > 0 ? Math.floor(Detail.Remember) : -Math.floor(Detail.Remember)) }}</span>
              </div>

              <div class="mt-1" style="font-size: 22px" v-if="!$IsAccess('lblCustomerRemember')">
                <span :class="Detail.Remember > 0 ? 'text-warning' : 'text-logo'">{{ $Comma3ragham(Detail.Remember > 0 ? 'بدهی دارد' : 'بدهی ندارد') }}</span>
              </div>

              <div class="mt-1">
                وضعیت پرداخت بدهی:
                <span :class="Customer.Customer.AdamPardaxtBedeh ? 'fas fa-circle text-danger' : 'fas fa-circle text-success'"></span>
              </div>
              <div class="mt-1">
                <button v-if="Customer.Customer.CustomerCode && Customer.Customer.CustomerCode > 0" @click="GoToTickets" class="btn btn-primary w-100">مشاهده تیکت های مشتری</button>
              </div>
              <!-- <div class="mt-1" style="font-size: 22px" v-else>
                <div v-if="Detail.Remember > 0" class="rubber_stamp-Red">بدهکـــار</div>
                <div v-if="Detail.Remember == 0" class="rubber_stamp">تسویه شده</div>
                <div v-if="Detail.Remember < 0" class="rubber_stamp">بستانـــکار</div>
              </div> -->
            </div>
            <div class="col-md-4 col-12 text-center">
              <div class="mt-3">
                <span> روش بازاریابی : </span><span> {{ Customer.Customer.tblCombogrp9RaveshBazaryabiName }} </span>
              </div>
              <div class="mt-2">
                <span> منبع بازاریابی : </span><span> {{ Customer.Customer.tblCombogrp22ManbaeMoarefiName }} </span>
              </div>
              <div class="mt-2">
                <span> گروه هدف : </span><span> {{ Customer.Customer.tblCombogrp3GroupName }} </span>
              </div>
              <div class="mt-2">
                <span> هدف : </span><span> {{ Customer.Customer.tblcombogrp9AvalinhadafBazayabiName }} </span>
              </div>
              <div class="mt-2" v-if="Customer.Customer.tblCombogrp35NoeMojavezYaEstandardName && Customer.Customer.tblCombogrp35NoeMojavezYaEstandardName != null && Customer.Customer.tblCombogrp35NoeMojavezYaEstandardName.trim() != ''">
                <span> مجوز : </span><span> {{ Customer.Customer.tblCombogrp35NoeMojavezYaEstandardName }} </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-12 text-right" v-if="Customer.Customer.DesCustomer && Customer.Customer.DesCustomer.length > 1">
              <div class="mt-2" v-if="Bishtar == false">
                <small> توضیحات: </small>
                <small> {{ Customer.Customer.DesCustomer && Customer.Customer.DesCustomer.length > 150 ? Customer.Customer.DesCustomer.slice(0, 150) + ' ... ' : Customer.Customer.DesCustomer }} </small>
                <small class="mx-2 Pointer" @click="Bishtar = true"> <i class="fad fa-angle-double-left text-danger"></i> </small>
              </div>
              <div class="mt-2" v-if="Bishtar == true">
                <small> توضیحات: </small>
                <small> {{ Customer.Customer.DesCustomer ? Customer.Customer.DesCustomer : '' }} </small>
                <small class="mx-2 Pointer" @click="Bishtar = false"> <i class="fad fa-angle-double-right text-danger"></i> </small>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
    <Card v-if="$store.state.renderComponentCard">
      <template v-slot:content>
        <tab :tab="Tablist" v-if="renderTab == true">
          <template v-slot:content0>
            <div class="container" v-if="$store.state.renderComponentGrid">
              <div class="row" v-if="Customer.Personel != null">
                <div class="mb-3">
                  <a v-if="AddModePersonel == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="AddModePersonel = 1" title="افزودن پرسنل جدید">
                    <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                  </a>
                  <a
                    v-if="AddModePersonel != 0"
                    class="d-inline float-right mx-2 mt-1"
                    href="javascript:;"
                    @click="
                      AddModePersonel = 0
                      Reload()
                    "
                    title="لغو افزودن"
                  >
                    <h4><i class="fas fa-times text-danger"></i></h4>
                  </a>
                </div>
                <div class="col-12">
                  <small id="LblDone "> نمایش بایگانی</small>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input InputText" id="ShowActive" v-model="ShowActive" @change="GetShowActive(ShowActive)" />
                    <label class="custom-control-label" for="ShowActive"> </label>
                  </div>
                </div>
                <div class="col-12" v-if="AddModePersonel != 0">
                  <div class="row" id="CustomerPersonel">
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LblFullName">نام و نام خانوادگی</small>
                        <input type="text" class="form-control InputText required" v-model="Personel.FullName" />
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LbltblcomboGrp1Semat">سمت</small>
                        <SearchableCombo
                          v-if="$store.state.renderComponentCombo"
                          :edit="false"
                          :grp="1"
                          :code="null"
                          @ResultCombo="ResultGrp1Semat"
                          :rownumintable="3"
                          :defaultvalue="Personel.tblcomboGrp1Semat"
                          :action="'TblCrmCombo/GetComboById'"
                          :method="'POST'"
                          :idinput="'Grp'"
                          :keyItem="'Grp'"
                          :disabled="false"
                          :ClassProps="'required'"
                        >
                        </SearchableCombo>
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LblPerTamas">تلفن</small>
                        <input type="text" class="form-control InputText" v-model="Personel.PerTamas" />
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LblPerMobile">همراه</small>
                        <input type="text" class="form-control InputText" v-model="Personel.PerMobile" />
                      </div>
                    </div>

                    <div class="col-md-2 col-12">
                      <div class="mt-3">
                        <small id="LblPerAge">سن</small>
                        <input type="number" class="form-control InputText" v-model="Personel.PerAge" />
                      </div>
                    </div>
                    <div class="col-md-4 col-12">
                      <div class="mt-3">
                        <small id="LblEmail">ایمیل</small>
                        <input type="text" class="form-control InputText" v-model="Personel.Email" />
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LblSendSmsTo"> پیامک</small>
                        <span class="form-control p-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" id="SendSms" v-model="Personel.SendSmsTo" />
                            <label class="custom-control-label" for="SendSms"> پیامک</label>
                          </div>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="mt-3">
                        <small id="LblIsActive">بایگانی</small>
                        <span class="form-control p-1">
                          <div class="custom-control custom-switch text-center">
                            <input type="checkbox" class="custom-control-input InputText" id="Archive" v-model="Personel.IsActive" />
                            <label class="custom-control-label" for="Archive"> بایگانی </label>
                          </div>
                        </span>
                      </div>
                    </div>

                    <div class="col-9">
                      <div class="mt-3">
                        <small id="LblPerTozihat">توضیحات بیشتر</small>
                        <textarea class="form-control InputText" rows="1" v-model="Personel.PerTozihat"></textarea>
                      </div>
                    </div>
                    <div class="col-3 mt-3">
                      <small id="LblPerMobileWhatsUp">شماره شبکه های مجازی</small>
                      <input type="email" class="form-control InputText" v-model="Personel.PerMobileWhatsUp" />
                    </div>
                    <div class="col-3 mt-3">
                      <small id="LblIsPerRabetAsli">رابط اصلی</small>
                      <span class="form-control p-1">
                        <div class="custom-control custom-switch text-center">
                          <input type="checkbox" class="custom-control-input InputText" id="IsPerRabetAsli" v-model="Personel.IsPerRabetAsli" />
                          <label class="custom-control-label" for="IsPerRabetAsli">رابط اصلی</label>
                        </div>
                      </span>
                    </div>
                    <div class="col-3 mt-3">
                      <button v-if="AddModePersonel == 1" class="btn btn-success mt-4 text-center w-100" @click="SetPersonel">ثبت پرســنل</button>
                      <button v-if="AddModePersonel == -1" class="btn btn-warning mt-4 text-center w-100" @click="EditPersonel">ویرایش پرســنل</button>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-else>
                  <div class="row">
                    <div v-for="(person, index) in Customer.Personel" :key="index" class="col-md-3 col-12 p-2">
                      <CardBox>
                        <template v-slot:cardbox-icon1>
                          <i v-if="person.IsActive == true" class="fad fa-archive mt-2" title="کاربر بایگانی شده"></i>
                          <i v-else-if="person.tblUserIdLogin != 0 && person.IsActive == false" class="fad fa-user-check mt-2" title=" کاربر سامانه CRM "></i>
                          <i v-else-if="person.IsPerRabetAsli" class="fad fa-user-crown mt-2" title=" کاربر اصلی "></i>
                        </template>
                        <template v-slot:cardbox-icon2><i v-if="person.IsActive != true && person.tblUserIdLogin == 0" class="fad fa-user mt-2"></i></template>
                        <template v-slot:b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="OnPersonelTicket(person)" v-if="!person.tblUserIdLogin">تنظیم به عنوان کاربر CRM </b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="OnclipBoard(person)" v-if="!person.IsActive == true">کپی تلفن</b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="Voip(person.PerMobile)" v-if="!person.IsActive && $session.get('UserInfo').voipExtension != null && Customer.voip.length > 1 && person.PerMobile"> تماس با {{ person.PerMobile }}</b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="Voip(person.PerTamas)" v-if="!person.IsActive && $session.get('UserInfo').voipExtension != null && Customer.voip.length > 1 && person.PerTamas"> تماس با {{ person.PerTamas }}</b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="OnEdit(person)">ویرایش</b-dropdown-item>
                          <b-dropdown-item href="#" class="text-center" @click="SendSms(person)" v-if="!person.IsActive == true && person.PerMobile">پیامک</b-dropdown-item>
                        </template>
                        <template v-slot:cardbox-body>
                          <h5 class="card-title text-center">{{ person.FullName }}</h5>
                          <p class="card-text detail mt-4">سمت : {{ person.tblcomboGrp1SematName }}</p>
                          <p v-if="person.PerTamas && person.PerTamas != ''" class="card-text detail">تلفن : {{ person.PerTamas }}</p>
                          <p v-if="person.PerMobile && person.PerMobile != ''" class="card-text detail">موبایل : {{ FormatMobile(person.PerMobile) }}</p>
                          <p v-if="person.PerMobileWhatsUp && person.PerMobileWhatsUp != ''" class="card-text detail">شبکه های مجازی : {{ FormatMobile(person.PerMobileWhatsUp) }}</p>
                          <!-- <p v-if="person.SendSmsTo && person.SendSmsTo!=false" class="card-text detail text-info">امکان ارسال پیامک</p> -->
                          <p v-if="person.PerTozihat && person.PerTozihat != ''" class="card-text detail">توضیحات : {{ person.PerTozihat }}</p>
                          <p v-if="person.Email && person.Email != '' && person.Email != null" class="card-text detail">ایمیل : {{ person.Email }}</p>
                        </template>
                      </CardBox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-else>
                <div class="text-center col-12">
                  <h4 class="text-danger">عدم دسترسی</h4>
                  <small>شما دسترسی لازم را به این بخش ندارید ، </small>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:content1>
            <div class="row" v-if="$session.get('Menu').filter((x) => x.RouteName == 'TaskManager')[0].isMojaz == 1">
              <a class="d-inline float-right mx-4 mt-1" href="javascript:;" @click="addTask" title="افزودن کـار جدید">
                <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
              </a>
              <div class="col-12">
                <TaskManager v-if="$store.state.renderComponentGrid" :CustomerIdprop="Customer.Customer.Id"> </TaskManager>
              </div>
            </div>
            <div class="row" v-else>
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content2>
            <Address v-if="$store.state.renderComponentGrid" :CustomerId="Customer.Customer.Id" :AdressList="Customer.Adress" @Inserted="refresh"></Address>
            <div class="row" v-if="Customer.Adress == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content3>
            <Communications v-if="$store.state.renderComponentGrid" :CommunicationList="Customer.communications" @Inserted="refresh" :CustomerId="Customer.Customer.Id"> </Communications>
            <div class="row" v-if="Customer.communications == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content4>
            <Survey v-if="$store.state.renderComponentGrid" :Surveys="Customer.Surveys" @Inserted="refresh" :CustomerId="Customer.Customer.Id"> </Survey>
            <div class="row" v-if="Customer.Surveys == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content5>
            <RemoteAccess v-if="$store.state.renderComponentGrid && Customer.AccessList != null" :AccessList="Customer.AccessList" @Inserted="refresh" :CustomerId="Customer.Customer.Id"></RemoteAccess>
            <div class="row" v-if="Customer.AccessList == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content6>
            <Anidcator v-if="$store.state.renderComponentGrid && $IsAccess('Andicator')" :AndicatorList="Customer.Andicator" :ftp="Customer.ftp" @Inserted="refresh" :CustomerId="Customer.Customer.Id" :Codebazaryabi="Customer.Customer.CodeBazaryabi"></Anidcator>
            <div class="text-center" v-else>
              <h4 class="text-danger">عدم دسترسی</h4>
              <small>شما دسترسی لازم را به این بخش ندارید ، </small>
            </div>
          </template>
          <template v-slot:content7>
            <Presence v-if="$store.state.renderComponentGrid" :PresenceList="Customer.Presence" :CustomerId="Customer.Customer.Id" @Inserted="refresh"></Presence>
            <div class="row" v-if="Customer.Presence == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content8>
            <Modules v-if="$store.state.renderComponentGrid && $IsAccess('ModulesTab')" :CustomerId="Customer.Customer.Id" :CustCode="Customer.Customer.CustomerCode" :CustomerName="Customer.Customer.CustomerName"></Modules>
            <div class="text-center" v-if="!$IsAccess('ModulesTab')">
              <h4 class="text-danger">عدم دسترسی</h4>
              <small>شما دسترسی لازم را به این بخش ندارید ، </small>
            </div>
          </template>
          <template v-slot:content9>
            <CustomerContract v-if="$store.state.renderComponentGrid && Customer.CustomerContract != null" :ContractList="Customer.CustomerContract" :CustomerId="Customer.Customer.Id" @Inserted="refresh"></CustomerContract>
            <div class="row" v-if="Customer.CustomerContract == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content10>
            <CustomerTempFactor v-if="$store.state.renderComponentGrid && Customer.TempFactorList != null" :CustomerId="Customer.Customer.Id" :TempFactorList="Customer.TempFactorList" @Inserted="refresh" @DetailDeposit="GotoDetailDeposit"></CustomerTempFactor>
            <div class="row" v-if="Customer.TempFactorList == null">
              <div class="text-center col-12">
                <h4 class="text-danger">عدم دسترسی</h4>
                <small>شما دسترسی لازم را به این بخش ندارید ، </small>
              </div>
            </div>
          </template>
          <template v-slot:content11>
            <CustomerDeposit v-if="$store.state.renderComponentGrid && $IsAccess('DepositTab') && Customer.CustomerDeposit != null" :CustomerId="Customer.Customer.Id" :DepositList="Customer.CustomerDeposit" @Inserted="refresh" @DetailDeposit="GotoDetailDeposit"></CustomerDeposit>
            <div class="text-center" v-if="!$IsAccess('DepositTab') || Customer.CustomerDeposit == null">
              <h4 class="text-danger">عدم دسترسی</h4>
              <small>شما دسترسی لازم را به این بخش ندارید ، </small>
            </div>
          </template>
        </tab>
      </template>
    </Card>
    <b-modal size="xl" centered id="modal-DetailDeposit">
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-danger" @click="close()">
          <span aria-hidden="true">&times;</span>
        </b-button>
        <h5>جزئیات قرارداد</h5>
      </template>

      <template #default>
        <div dir="rtl">
          <BnpGrid v-if="$store.state.renderComponentGridModal" :hasRowNum="true" :propsColumn="ColumnDetail" :propsRows="RowsDetail" :action="false">
            <template slot="TotallAmount" slot-scope="props">
              <span>{{ $Comma3ragham(Math.floor(props.props.TotallAmount)) }}</span>
            </template>
            <template slot="Amount" slot-scope="props">
              <span>{{ $Comma3ragham(Math.floor(props.props.Amount)) }}</span>
            </template>
          </BnpGrid>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
      </template>
    </b-modal>

    <Modal v-if="$store.state.Modal && ListChange" @Close="closeModal" :InheritanceTheme="true" :IsFooter="false" :Size="'Lg'">
      <template v-slot:header>
        <h4 class="mr-4 d-inline text-warning">لیست تغییرات {{ Customer.Customer.CustomerName }}</h4>
        <hr />
      </template>
      <template v-slot:body>
        <CustomerLog :tblCustomerId="Customer.Customer.Id"></CustomerLog>
      </template>
      ></Modal
    >
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Tab from '@/components/Tab/Tab.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import CardBox from '@/components/CardBox/CardBox'
import Address from './Components/Address.vue'
import CustomerLog from './Components/CustomerLog.vue'
import Communications from './Components/Communications.vue'
import CustomerContract from './Components/CustomerContract.vue'
import CustomerDeposit from './Components/CustomerDeposit.vue'
import Anidcator from './Components/Anidcator.vue'
import Presence from '@/pages/BnpCrm/Presence/Presence'
import TaskManager from '../Tasks/TaskManager.vue'
import Modules from '../Modules/Modules.vue'
import RemoteAccess from './Components/RemoteAccess.vue'
import Survey from './Components/Survey.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import CustomerTempFactor from './Components/CustomerTempFactor.vue'
import Modal from '@/pages/Modal/Modal.vue'

export default {
  props: ['tblCustomerId', 'activeTab'],
  components: { BnpGrid, Card, Tab, SearchableCombo, TaskManager, CardBox, Address, Communications, Anidcator, Presence, Modules, CustomerContract, CustomerDeposit, RemoteAccess, Survey, CustomerTempFactor, Modal, CustomerLog },
  data() {
    return {
      ListChange:false,
      renderTab: true,
      active: 0,
      Tablist: [],
      Customer: null,
      AddModePersonel: 0,
      Personel: {
        IsPerRabetAsli: false,
        SendSmsTo: false,
        IsActive: false,
        tblcomboGrp1Semat: 1165,
        TblUserGrpIdInsert: this.$session.get('UserInfo').tblUserGrpId,
      },

      ShowActive: false,
      PersonelList: [],
      Bishtar: false,
      Detail: {},
      ColumnDetail: [
        { id: 2416, name: 'Name', visibility: true, label: 'نام محصول' },
        { id: 2416, name: 'TotallAmount', visibility: true, label: 'مبلغ کل محصول' },
        { id: 2416, name: 'Amount', visibility: true, label: 'مبلغ واریزی' },
        { id: 2416, name: 'TblContractId', visibility: true, label: 'شماره قرارداد ' },
      ],
      RowsDetail: [],
      AllPersonel: [],
    }
  },
  created() {
    this.active = this.$store.state.activeTab ? this.$store.state.activeTab : 0
    this.$store.state.renderComponentCard = false
    this.GetCustomerDetail(true)
    this.$GetAccessUser()
    if (this.$IsAccess('DepositTab')) {
      this.Tablist.push({ header: 'واریزی ها', active: this.active == 10 })
      this.Tablist.push({ header: 'واریزی ها', active: this.active == 10 })
      this.renderTab = false
      this.$nextTick(() => {
        this.renderTab = true
      })
    }
  },

  methods: {
    OpenLog() {
      this.$store.state.Modal = true
      this.ListChange = true
    },
    closeModal() {
      this.$store.state.Modal = false
      this.ListChange = false
    },
    GetShowActive(data) {
      if (!data) {
        this.Customer.Personel = this.AllPersonel.filter((x) => x.IsActive == false)
      } else {
        this.Customer.Personel = this.AllPersonel
      }
    },
    FormatMobile(Num) {
      var formated = ''
      if (Num.length == 11) {
        return Num.slice(7, 11) + '-' + Num.slice(4, 7) + '-' + Num.slice(0, 4)
      } else {
        return formated
      }
    },
    GoToTickets() {
      this.$router.push({ name: 'Tickets', params: { FromCustomer: true, PropsCustomer: this.$store.state.tblCustomerId } })
    },
    Voip(number) {
      // console.log(this.Customer.voip.replace('##', number).replace('**', this.$session.get('UserInfo').voipExtension))
      var axios = require('axios')
      var config = {
        method: 'POST',
        url: this.Customer.voip.replace('##', number).replace('**', this.$session.get('UserInfo').voipExtension),
        headers: {},
        data: null,
      }
      axios(config).then((response) => response.data)
    },
    isactive(num) {
      return this.$store.state.activeTab == num
    },
    GotoDetailDeposit(data) {
      this.$bvModal.show('modal-DetailDeposit')
      this.RowsDetail = data
    },
    addTask() {
      this.$router.push({ name: 'DetailTask', params: { Status: 'Add', PropsCustomer: this.Customer.Customer.Id } })
    },
    SendSms(personel) {
      if (personel.PerMobile.trim().length != 11) {
        this.$mySweetDefaultTost('خطا', 'شماره موبایل ثبت شده صحیح نیست', 'error', 1500)
      } else {
        this.$store.state.Customer.Customer = this.Customer.Customer

        this.$router.push({ name: 'CustomerSms', params: { personel: personel, PerMobile: personel.PerMobile, PerName: personel.FullName, PerId: personel.Id, CustomerId: personel.tblCustomerId, CustomerName: this.Customer.Customer.CustomerName } })
      }
    },
    GetCustomerDetail(IsCreated) {
      this.$store.state.loading = true
      this.$GetCustomerDetail(this.$store.state.tblCustomerId)
        .then((data) => {
         // console.log('😎 ~ .then ~ data:', data)
          this.$store.state.loading = false
          this.Customer = data
          this.AllPersonel = JSON.parse(JSON.stringify(this.Customer.Personel))

          // console.log(data)
          this.$store.state.renderComponentGrid = false
          this.$store.state.renderComponentCard = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
            this.$store.state.renderComponentCard = true
            this.$CalcBedehiCustomer(this.Customer.Customer.Id).then((result) => {
              this.Detail = result[0]
            })
          })
        })
        .finally(() => {
          if (IsCreated) this.GetShowActive(false)
        })
      /*  var DataAxiosGetCustomer = { Action: 'TblCustomerCrm/GetFullCustomer', Method: 'Post', ArryfildValue: { id: this.$store.state.tblCustomerId } }
      this.$PostData(DataAxiosGetCustomer).then((result) => {

        this.$store.state.renderComponentGrid = false
        this.$nextTick(() => {
          this.$store.state.renderComponentGrid = true
          this.$store.state.renderComponentCard = true
          this.$CalcBedehiCustomer(this.Customer.Customer.Id).then((result) => {
            this.Detail = result[0]
          })
        })
      })*/
    },
    ResultGrp1Semat(dataResult) {
      this.Personel.tblcomboGrp1SematName = dataResult.name
      this.Personel.tblComoId1Semat = dataResult.id
    },
    SetPersonel() {
      if (this.$ValidForm('CustomerPersonel')) {
        this.Personel.tblCustomerId = this.Customer.Customer.Id
        this.Personel.Id = 1
        this.AddModePersonel = false
        var DataAxiosSetPersonel = { Action: 'CustomerPersonel', Method: 'Post', ArryfildValue: this.Personel }
        this.$PostData(DataAxiosSetPersonel).then((result) => {
          this.Reload()
          this.GetCustomerDetail(true)
        })
      }
    },
    refresh(data) {
      this.GetCustomerDetail(true)
      this.$store.state.activeTab = data.activeTab
      this.Tablist = [
        { header: 'پرسنل', active: this.isactive(0) },
        { header: 'کارها', active: this.isactive(1) },
        { header: 'آدرس ها', active: this.isactive(2) },
        { header: 'تماسها', active: this.isactive(3) },
        { header: 'پرشسنامه ها', active: this.isactive(4) },
        { header: 'دسترسی راه دور', active: this.isactive(5) },
        { header: 'نامه و فایل ها', active: this.isactive(6) },
        { header: 'دمو | حضور', active: this.isactive(7) },
        { header: 'ماژول', active: this.isactive(8) },
        { header: 'قرارداد ها', active: this.isactive(9) },
      ]
      if (this.$IsAccess('DepositTab')) {
        this.Tablist.push({ header: 'پیش فاکتور ها', active: this.isactive(11) })
        this.Tablist.push({ header: 'واریزی ها', active: this.active == 10 })
        this.renderTab = false
        this.$nextTick(() => {
          this.renderTab = true
        })
      } else {
        this.renderTab = false
        this.$nextTick(() => {
          this.renderTab = true
        })
      }
    },
    OnEdit(row) {
      row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.Personel = row
      this.Personel.tblcomboGrp1Semat = row.tblComoId1Semat
      this.AddModePersonel = -1
      this.$store.state.OldDataForLog = JSON.stringify(this.Personel)
    },
    Reload() {
      this.Personel = { IsPerRabetAsli: false, SendSmsTo: false, IsActive: false, tblcomboGrp1Semat: 1165 }
    },
    EditPersonel() {
      if (this.$ValidForm('CustomerPersonel')) {
        // this.Personel.tblCustomerId=this.Customer.Customer.Id
        var DataAxiosEditPersonel = { Action: 'CustomerPersonel', Method: 'Put', ArryfildValue: this.Personel }
        this.$PostData(DataAxiosEditPersonel).then((result) => {
          this.$SetLog(this.Personel, 0, 0, 'CustomerPersonel', 'پرسنل مشتری')
          this.AddModePersonel = 0
          this.Reload()
          this.GetCustomerDetail(true)
        })
      }
    },
    OnclipBoard(person) {
      navigator.clipboard.writeText(person.PerMobile && person.PerMobile.trim() != '' ? person.PerMobile : person.PerTamas)
      this.$toasted.success(' شماره تلفن ' + person.FullName + ' کپی شد', {})
    },
    OnEditCustomer() {
      this.$router.push({
        name: 'AddCustomer',
        params: { Status: 'Edit', Customer: this.Customer.Customer },
      })
    },
    OnPersonelTicket(person) {
      this.$router.push({ name: 'PersonelTicket', params: { tblCustomerId: person.tblCustomerId, Personel: person } })
    },
    OnCustomerFinancialInvoice() {
      this.$router.push({ name: 'CustomerFinancialInvoice', params: { CustomerName: this.Customer.Customer.CustomerName, CustomerCode: this.Customer.Customer.CustomerCode, tblCustomerId: this.Customer.Customer.Id } })
    },
  },
  mounted() {
    if (!this.$store.state.tblCustomerId) {
      this.$router.push({
        name: 'CustomerManager',
      })
    }

    this.Tablist = [
      { header: 'پرسنل', active: this.isactive(0) },
      { header: 'کارها', active: this.isactive(1) },
      { header: 'آدرس ها', active: this.isactive(2) },
      { header: 'تماسها', active: this.isactive(3) },
      { header: 'پرشسنامه ها', active: this.isactive(4) },
      { header: 'دسترسی راه دور', active: this.isactive(5) },
      { header: 'نامه و فایل ها', active: this.isactive(6) },

      { header: 'دمو | حضور', active: this.isactive(7) },
      { header: 'ماژول', active: this.isactive(8) },
      { header: 'قرارداد ها', active: this.isactive(9) },
    ]
    if (this.$IsAccess('DepositTab')) {
      this.Tablist.push({ header: 'پیش فاکتور ها', active: this.isactive(11) })
      this.Tablist.push({ header: 'واریزی ها', active: this.active == 10 })
      this.renderTab = false
      this.$nextTick(() => {
        this.renderTab = true
      })
    } else {
      this.renderTab = false
      this.$nextTick(() => {
        this.renderTab = true
      })
    }
  },
  updated() {},
}
</script>
<style scoped>
.rubber_stamp {
  font-family: 'IRANSansWeb', sans-serif;
  font-size: 39px;
  line-height: 45px;
  text-transform: uppercase;
  font-weight: bold;
  color: rgb(102, 184, 20);
  border: 7px solid rgb(102, 184, 20);
  float: left;
  padding: 10px 7px;
  border-radius: 10px;

  opacity: 0.6;
  -webkit-transform: rotate(-10deg);
  -o-transform: rotate(-10deg);
  -moz-transform: rotate(-10deg);
  -ms-transform: rotate(-10deg);
  position: absolute;
  top: 20%;
  z-index: 100;
}
.rubber_stamp::after {
  position: absolute;
  content: ' ';
  width: 100%;
  height: auto;
  min-height: 100%;
  top: -10px;
  left: -10px;
  padding: 10px;
  /* background: url(https://raw.github.com/domenicosolazzo/css3/master/img/noise.png) repeat; */
}
.rubber_stamp-Red {
  font-family: 'IRANSansWeb', sans-serif;
  font-size: 39px;
  line-height: 45px;
  text-transform: uppercase;
  font-weight: bold;
  color: rgb(197, 72, 18);
  border: 7px solid rgb(197, 72, 18);
  float: left;
  padding: 10px 7px;
  border-radius: 10px;

  opacity: 0.6;
  -webkit-transform: rotate(-10deg);
  -o-transform: rotate(-10deg);
  -moz-transform: rotate(-10deg);
  -ms-transform: rotate(-10deg);
  position: absolute;
  top: 20%;
  z-index: 100;
}
.rubber_stamp-Red::after {
  position: absolute;
  content: ' ';
  width: 100%;
  height: auto;
  min-height: 100%;
  top: -10px;
  left: -10px;
  padding: 10px;
  /* background: url(https://raw.github.com/domenicosolazzo/css3/master/img/noise.png) repeat; */
}
</style>
